import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import useSeo from "@/lib/useSeo";
import { QuoteProvider } from "@/components/QuoteDialog";
import MobileStickyCTA from "@/components/MobileStickyCTA";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import PainSection from "@/components/PainSection";
import SolutionSection from "@/components/SolutionSection";
import WhatYouCreate from "@/components/WhatYouCreate";
import ProductEcosystem from "@/components/ProductEcosystem";
import WhyChoose from "@/components/WhyChoose";
import HowItWorks from "@/components/HowItWorks";
import HomeVisibilityCheck from "@/components/HomeVisibilityCheck";
import Objection from "@/components/Objection";
import CTABand from "@/components/CTABand";
import TrustSection from "@/components/TrustSection";
import Footer from "@/components/Footer";
import PrintersPage from "@/pages/PrintersPage";
import FinishingPage from "@/pages/FinishingPage";
import SuppliesPage from "@/pages/SuppliesPage";
import BundlesPage from "@/pages/BundlesPage";
import VisibilityCheckPage from "@/pages/VisibilityCheckPage";
import SchoolVisibilityPlaybookPage from "@/pages/SchoolVisibilityPlaybookPage";

const Home = () => {
  const location = useLocation();
  useSeo({
    title: "ED Tech Depot — In-House Poster & Banner Printing for K-12 Schools",
    description:
      "Give your K-12 school the ability to print posters, banners, and signage in-house — with Canon wide-format printers, supplies, laminators, vinyl cutters, and complete bundled systems.",
    path: "/",
  });
  useEffect(() => {
    if (location.hash) {
      // Allow layout/images to settle before scrolling.
      const id = location.hash;
      const tryScroll = () => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      const t1 = setTimeout(tryScroll, 100);
      const t2 = setTimeout(tryScroll, 600);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
  }, [location.hash]);

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#F4F6F4]">
      <Header />
      <main>
        <Hero />
        <PainSection />
        <SolutionSection />
        <WhatYouCreate />
        <ProductEcosystem />
        <WhyChoose />
        <HomeVisibilityCheck />
        <HowItWorks />
        <Objection />
        <CTABand />
        <TrustSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <QuoteProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/printers" element={<PrintersPage />} />
            <Route path="/finishing" element={<FinishingPage />} />
            <Route path="/supplies" element={<SuppliesPage />} />
            <Route path="/bundles" element={<BundlesPage />} />
            <Route path="/visibility-check" element={<VisibilityCheckPage />} />
            <Route
              path="/school-visibility-playbook"
              element={<SchoolVisibilityPlaybookPage />}
            />
          </Routes>
          <MobileStickyCTA />
        </QuoteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
